import { z } from "zod";
import { NoneAuthSchema, BearerAuthSchema, HttpAuthSchema, AwsAuthSchema, ProxyAuthSchema, PublicationType, RendererType, AllowedFormatsFree, AllowedRenderersFree, AllowedRenderersFreeSet, AllowedFormatsFreeSet } from "../types";
import { AddonConfigSchema } from "../addons/schema";
import { AnyLayoutSchema } from "../layout";

export const FreeV2Schema = z.object({
    plan: z.literal("free"),
    version: z.literal("free@2"),
    lastUpdated: z.string().datetime(),
    addons: AddonConfigSchema,
    layout: AnyLayoutSchema.default({"version":"layout@1", "regions": {}}),
    private: z.object({
        origin: z.string().optional(),
        security: z.object({
            permittedUrls: z.array(z.string()).optional(),
            requirePreAuthorisation: z.boolean().optional()
        }).optional(),
        authentication: z.union([
            NoneAuthSchema,
            BearerAuthSchema,
            HttpAuthSchema,
            AwsAuthSchema,
            ProxyAuthSchema,
        ]),
    }),
    public: z.object({
        publication: z.object({
            key: z.string().optional()
        }).optional(),
        fonts: z.object({
            name: z.literal("components.publication_default")
        }).default({"name":"components.publication_default"}).optional(),
        settings: z.object({
			ignoreAspectRatio: z.object({
				enabled: z.boolean().default(false),
				value: z.boolean().default(false)
			}),
			fontSize: z.object({
				enabled: z.boolean().default(false),
				value: z.string().default('100%')
			}),
			fontFamily: z.object({
				enabled: z.boolean().default(false),
				value: z.string().default('components.publication_default')
			}),
		}).partial().optional(),
        languages: z.array(z.string()).optional(),
        formats: z.array(PublicationType)
            .default([...AllowedFormatsFree] as PublicationType[])
            .transform((formats) =>
                formats.filter(
                    (r): r is (typeof AllowedFormatsFree)[number] =>
                    AllowedFormatsFreeSet.has(r),
                ),
        ),
        renderers: z.array(RendererType)
            .default([...AllowedRenderersFree] as RendererType[])
            .transform((renderers) =>
                renderers.filter(
                    (r): r is (typeof AllowedRenderersFree)[number] =>
                    AllowedRenderersFreeSet.has(r),
                ),
        ),
    })
});

export type FreeV2 = z.infer<typeof FreeV2Schema>;